var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vx-card',{attrs:{"title":"Fortschritt","title-color":"black","subtitle":"Der Fortschritt bei der Beantwortung des Fragebogens."}},[_c('vue-apex-charts',{attrs:{"type":"bar","height":"250","options":_vm.barChart.chartOptions,"series":_vm.barChart.series}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }